<template>

<app-view-sheet-field align="center" :is-sticky="isSticky" :field="field" :filter="filter">

    <span v-if="value !== false">{{ value | round(2) }}%</span>

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky'],

    computed: {

		value: function() {

			if (this.item.record.results) {

				return (100 / this.item.record.results) * this.item.record.wins

			} else {

				return false

			}

		}

    }

}

</script>

<style scoped>

</style>